import { Fragment } from "react";

export default function DevelopmentCycle() {
  const cycle = [
    {
      title: "Plan",
      description: "Discover & Define",
      imgUrl: "https://glocify.com/images/plan-new-icon.svg",
      bgColor: "bg-[#EF5A46]"
    },
    {
      title: "Design",
      description: "Create Visuals",
      imgUrl: "https://glocify.com/images/design-new-icon.svg",
      bgColor: "bg-[#7C46EF]"
    },
    {
      title: "Build",
      description: "Build & construct",
      imgUrl: "https://glocify.com/images/build-new-icon.svg",
      bgColor: "bg-[#EF46B6]"
    },
    {
      title: "Test",
      description: "Train & Test",
      imgUrl: "https://glocify.com/images/test-new-icon.svg",
      bgColor: "bg-[#466BEF]"
    },
    {
      title: "Launch",
      description: "Optimize & Go Live",
      imgUrl: "https://glocify.com/images/launch-new-icon.svg",
      bgColor: "bg-[#9046EF]"
    },
  ];
  return (
    <div className="flex lg:items-end lg:flex-row flex-col justify-center lg:gap-5 gap-3 lg:px-12 lg:mt-[-40px] lg:mb-28 mb-10 lg:py-0 py-8">
      {cycle.map((item, index) =>
      <Fragment  key={index}>
        <div className="text-center min-w-[145px]">
          <div
            className={`${item.bgColor} w-[80px] h-[80px] rounded-2xl flex items-center justify-center mb-6 mx-auto`}
          >
            <img src={item?.imgUrl} alt={item?.title} className="w-[50px]"/>
          </div>
          <h3 className="lg:text-[30px] font-medium lg:leading-[39px] tracking-tight text-[#333333]">
            {item?.title}
          </h3>
          <p className="text-[15px] leading-[22px] font-medium text-[#313131]">
            {item?.description}
          </p>
        </div>
        {index < cycle.length - 1 && (
            <div className="flex items-center justify-center lg:min-h-[80px] min-h-[50px]">
              <img
                src="https://glocify.com/images/dark-arrow.svg"
                alt="arrow"
                className="w-6 h-6 lg:w-8 lg:h-8 lg:rotate-0 rotate-90"
              />
            </div>
          )}
      </Fragment >
      )}
    </div>
  );
}
